// extracted by mini-css-extract-plugin
export default {"subRating":"ZsR28"};